import { ConcreteEncodable } from "./ConcreteEncodable";

import { ConsumerChannelImplEncoder } from "../../encoder/ConsumerChannelImplEncoder";

import * as CubiqTS from "../../index";
import { ConsumerChannel } from "../ConsumerChannel";

export class ConsumerChannelImpl extends ConcreteEncodable implements ConsumerChannel {
  public static enType: string = "com.bcdfx.service.messaging.impl.ConsumerChannelImpl";

  /*FID=1*/
  public channelName: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ConsumerChannelImplEncoder.Instance;
    this.setEncodableType(ConsumerChannelImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ConsumerChannelImpl[" +
      "channelName=" +
      this.channelName +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
